import React from "react";
import { Label, Input } from "reactstrap";

const DurationDropdown = ({ value, onChange, label = "Duration", className="" }) => {
  return (
      <div className={`col-md-12 col-sm-12 ${className}`}>
        <Label>{label}</Label>
        <Input
          type="select"
          name="select"
          value={value}
          className="form-control digits uiStyleDashboard"
          onChange={onChange}
        >
          {["Select", "Daily", "Weekly", "Monthly"].map((item) => {
            return <option value={item}>{item}</option>;
          })}
        </Input>
      </div>
  );
};

export default DurationDropdown;
